import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/pickem')({
  component: PickemLayout,
});

function PickemLayout() {
  return <Outlet />;
}
